"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = void 0;
exports.fetchData = fetchData;
exports.host = exports.getQueryParams = exports.getItemLabel = void 0;
var _logger = require("../logger");
var _catchPromiseError = require("./catchPromiseError");
var _getUrl = require("./getUrl");
/* eslint-disable @typescript-eslint/naming-convention -- using external library variable names */

const utilityName = 'googleGeocodingSearch';
const catchError = async promise => (0, _catchPromiseError.catchPromiseError)(promise, `Error in ${utilityName}`);

/**
No config for here-used API URL in BackOffice ATM, and probably no need for it.
The API URL setting there https://maps.googleapis.com/maps/api/js
is rather a map control script, so probably not much of use here.
API key from BO seems to work here though.

https://maps.googleapis.com/maps/api/geocode/json?address=1%20Microsoft%20Way%20Redmond%20WA%2098052&key={credentials}
*/
const basePath = exports.basePath = '/maps/api/geocode/json';
const host = exports.host = 'https://maps.googleapis.com';
const getQueryParams = (searchText, {
  mapAccount: {
    credentials
  }
}, maxDisplayedSearchResults) => ({
  address: searchText,
  key: credentials
  // TO-DO: language: localeString,
  // TO-DO: maxResults: maxDisplayedSearchResults, // doesn't seem to be supported
});
exports.getQueryParams = getQueryParams;
const getItemLabel = item => item.formatted_address;
exports.getItemLabel = getItemLabel;
const transformData = data => {
  (0, _logger.logDebug)(`${utilityName} transformData(): data before transformation:\n\t`, data);
  const results = (data?.results ?? []).map((item, index) => {
    const {
      place_id,
      geometry: {
        location
      }
    } = item;
    return {
      id: place_id,
      label: getItemLabel(item),
      // The casts here needed due to wrong typings - linter wants to call lat()
      // instead of lat here, which causes exception, as it is already evaluated to number, not a function.
      position: {
        latitude: Number(location.lat),
        longitude: Number(location.lng)
      }
    };
  });
  (0, _logger.logInfo)(`${utilityName}: loaded data after transformation:\n\t`, results);
  return {
    results
  };
};
async function fetchData(options) {
  (0, _logger.logInfo)(`${utilityName}: Loading data ...`);
  const promise = catchError((0, _getUrl.getUrl)({
    ...options,
    // Avoid CORS problems
    isAddingSpecialHeadersForbidden: true
  }));
  const data = await promise;
  return transformData(data);
}